import { render, staticRenderFns } from "./PersonCheckInItem.vue?vue&type=template&id=674c75e0&"
import script from "./PersonCheckInItem.vue?vue&type=script&lang=js&"
export * from "./PersonCheckInItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports